// extracted by mini-css-extract-plugin
export default {"toolLabelWrapper":"ToolLabel_toolLabelWrapper__sPbBu","toolLabelText":"ToolLabel_toolLabelText__offEV"};